export default "__VITE_ASSET__Bu6wZCzm__"